/** Live progress while journals are posted — driven by polling GET runs/{id}. */
import type { Run } from "../../payroll/api";

export default function SubmitProgress({ run }: { run: Run }) {
  const done = run.journals.filter((j) => j.status === "draft_created" || j.status === "failed").length;

  return (
    <div className="progress-card">
      <div className="progress-card__head">
        <span className="spinner" aria-hidden />
        <strong>Posting draft journals — {done} of {run.journals.length}</strong>
      </div>

      <div className="progress-bar">
        <div className="progress-bar__fill" style={{ width: `${Math.round((done / Math.max(run.journals.length, 1)) * 100)}%` }} />
      </div>

      <div className="progress-list">
        {run.journals.map((j) => (
          <div className="progress-list__row" key={j.importDocRef}>
            <span className={`progress-icon progress-icon--${j.status}`}>
              {j.status === "draft_created" ? "✓" : j.status === "failed" ? "✕" : j.status === "posting" ? "•" : "·"}
            </span>
            <span>{j.payrollName}</span>
            <span className="muted num">
              {j.status === "draft_created" ? `draft ${j.iplicitDocNo}`
                : j.status === "failed" ? "failed"
                : j.status === "posting" ? "posting…"
                : "queued"}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
}
